import React, { forwardRef } from 'react'
import { find, isUndefined, isNumber } from 'lodash';
import { hasPermission, isSuperOrTenantAdmin } from 'utils/authService';
import { Admin, PermissionSetMap, ROLE_SUPERADMIN, ROLE_TENANTADMIN } from 'constants/RBACConstants';
import UserFormV2 from './UserFormV2';

export function amIAdminInThisBUOrHasPermissionToModify(selfData, currentFieldValue, editUser) {
	if(isUndefined(currentFieldValue)) {
		return false;
	}

	if(!isNumber(currentFieldValue.businessUnitId)) { // This means no BU is selected
		return true;
	}

	if(isSuperOrTenantAdmin()){
		return true
	}
	
	const myBuLevelData = find(selfData?.data, { businessUnitId: currentFieldValue.businessUnitId });
	const myRole = selfData?.tenantRole || myBuLevelData?.role;

	if (hasPermission(editUser ? PermissionSetMap.UPDATE_USER : PermissionSetMap.CREATE_USER) && myRole) {
		if (currentFieldValue.canBeModified || isUndefined(currentFieldValue.canBeModified)) { // undefined means new BU is being added
			return true;
		}
	}

	return ([ROLE_SUPERADMIN, ROLE_TENANTADMIN, Admin].indexOf(myRole) !== -1);
}


export default forwardRef (function UserForm(props, ref) {
	const commonProp = {...props, ref };
	return <UserFormV2 {...commonProp}/>
})